export const API_TIMEOUTS = {
  DEFAULT: 60000,
};
